const ADMIN_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || "rogerrumbu@gmail.com").toLowerCase();

export function isSuperadmin(user) {
  return (user?.email || "").toLowerCase() === ADMIN_EMAIL;
}

export function is2RAAdmin(user) {
  return user?.role === "admin" && (user?.organization || "").trim().toUpperCase() === "2RA-EDITION";
}

export function canManageOrg(user) {
  return isSuperadmin(user) || is2RAAdmin(user);
}
